import { createSelector } from 'reselect';

import { StoreState } from '../index';

export const axiosInterceptionState = (state: StoreState) => state.axiosInterception;

export const requestErrorSelector = createSelector(
  axiosInterceptionState,
  (gs) => gs.requestError,
);

export const isSomeApiFetchingSelector = createSelector(
  axiosInterceptionState,
  (gs) => gs.isSomeApiFetching,
);

export const isApiCausedPageErrorSelector = createSelector(
  axiosInterceptionState,
  (gs) => gs.isApiCausedPageError,
);
